module.exports = __webpack_public_path__ + "static/img/3.0b83154.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/3.jpg
// module id = rRXf
// module chunks = 1